import React, { useEffect, useState } from "react";
import CommonForm from "../../../../../../components/commonform/commonForm";
import Snackbar from "../../../../../../components/snackbar/snackbar";
import { EmailValidate } from "../../../../../../components/formValidate";
import { institution_data } from "../../../../user.api";

let area_management = [{ id: "1" }, { id: "2" }, { id: "3" }];
export default function AreaDetails(props) {
  const [formData, setFormData] = useState(props.data);
  const [count, setCount] = useState(1);

  const [defaultkey, setdefaultkey] = useState(props.defaultkey);

  const [snackMessage, setSnackMessage] = useState("");
  const [institutions, setInstitutions] = useState([]);
  const [selectedCatId, setSelectedCatId] = useState("");
  const [orgdata, setOrgData] = useState([]);
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [institutionError, setInstitutionError] = useState("");
  const [showGroupMembers, setShowGroupMembers] = useState(false);
  const [error, setError] = useState({});
  useEffect(() => {
    if (!formData.students) {
      setFormData({
        ...formData,
        students: [
          {
            branch: "",
            student_name: "",
            semester: "",
            // mark: "",
            // upload_proposal: null,
          },
        ],
      });
    }
  }, [formData.students, formData]);
  const fetchCategory = () => {
    institution_data()
      .then((res) => {
        setInstitutions(res?.data);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      });
  };

  useEffect(() => {
    fetchCategory();
  }, []);

  const handleCategoryChange = (e) => {
    const selectedId = e.target.value;

    if (selectedId === "others") {
      setSelectedCatId("others");

      setFormData({
        ...formData,
        institution_id: "others",
        institution_name: "Others",
      });

      setSnackMessage(
        "Academic institution is not registered with us, please contact your institution head and register your academic institution with KSPACE."
      );
      setIsSnackError(true);
      setSnackOpen(true);

      return;
    }

    setInstitutionError("");
    setSelectedCatId(selectedId);

    const selectedInstitution = institutions.find(
      (inst) => inst.id.toString() === selectedId
    );

    setFormData({
      ...formData,
      institution_id: selectedId,
      institution_name: selectedInstitution?.institution_name || "",
    });
  };

  const handlepreview = (e) => {
    e.preventDefault();
    let flag = true;
    if (formData.institution_id === "others") {
      setSnackOpen(true);
      setSnackMessage("Please select a valid institution before proceeding.");
      setIsSnackError(true);
      return;
    }
    if (
      formData.file_upload_proposal !== null &&
      formData.file_upload_proposal !== undefined &&
      formData.file_upload_proposal !== ""
    ) {
      // if (setShowGroupMembers) {
      //   formData.students.forEach((item) => {
      //     if (
      //       item.photo === null ||
      //       item.photo === undefined ||
      //       item.photo === ""
      //     ) {
      //       flag = false;
      //       setSnackOpen(true);
      //       setSnackMessage(
      //         `Please choose a valid photo for ${item.student_name}`
      //       );
      //       setIsSnackError(true);
      //     }
      //     if (
      //       error.project_guide1_email === true ||
      //       error.project_guide2_email === true
      //     ) {
      //       flag = false;
      //       setSnackOpen(true);
      //       setSnackMessage(`Please enter a valid email`);
      //       setIsSnackError(true);
      //     }
      //   });
      // }
      if (flag) {
        props.action(0, formData);
      }
    } else {
      setSnackOpen(true);
      setSnackMessage("Please choose a valid proposal file");
      setIsSnackError(true);
    }
  };
  const handleMarkListChange = (e) => {
    let file = e.target.files[0];
    if (!file) return;

    let fileKey = e.target.name;
    let fileType = file.name.split(".").pop().toLowerCase();
    if (fileKey === "leader_marklist") {
      const allowedTypes = ["pdf"];

      if (allowedTypes.includes(fileType)) {
        let fileSizeMB = file.size / Math.pow(1024, 2);

        if (fileSizeMB < 1) {
          setFormData((prevData) => ({
            ...prevData,
            leader_marklist_name: file.name,
            leader_marklist: file,
          }));
        } else {
          setSnackMessage("File size is greater than 1MB");
          setIsSnackError(true);
          setSnackOpen(true);
          setFormData((prevData) => ({
            ...prevData,
            leader_marklist_name: null,
            leader_marklist: null,
          }));
        }
      } else {
        setSnackMessage("File should be in .pdf format");
        setIsSnackError(true);
        setSnackOpen(true);
        setFormData((prevData) => ({
          ...prevData,
          brochure_name: null,
          brochure: null,
        }));
      }
    }
  };
  const handleResumeUploadChange = (e) => {
    let file = e.target.files[0];
    if (!file) return;

    let fileKey = e.target.name;
    let fileType = file.name.split(".").pop().toLowerCase();
    if (fileKey === "leader_resume") {
      const allowedTypes = ["pdf"];

      if (allowedTypes.includes(fileType)) {
        let fileSizeMB = file.size / Math.pow(1024, 2);

        if (fileSizeMB < 1) {
          setFormData((prevData) => ({
            ...prevData,
            leader_resume_name: file.name,
            leader_resume: file,
          }));
        } else {
          setSnackMessage("File size is greater than 1MB");
          setIsSnackError(true);
          setSnackOpen(true);
          setFormData((prevData) => ({
            ...prevData,
            leader_resume_name: null,
            leader_resume: null,
          }));
        }
      } else {
        setSnackMessage("File should be in .pdf format");
        setIsSnackError(true);
        setSnackOpen(true);
        setFormData((prevData) => ({
          ...prevData,
          brochure_name: null,
          brochure: null,
        }));
      }
    }
  };
  const handleProposalFileUploadChange = (e) => {
    let file = e.target.files[0];
    if (!file) return;

    let fileKey = e.target.name;
    let fileType = file.name.split(".").pop().toLowerCase();
    if (fileKey === "file_upload_proposal") {
      const allowedTypes = ["pdf"];

      if (allowedTypes.includes(fileType)) {
        let fileSizeMB = file.size / Math.pow(1024, 2);

        if (fileSizeMB < 1) {
          setFormData((prevData) => ({
            ...prevData,
            file_upload_proposal_name: file.name,
            file_upload_proposal: file,
          }));
        } else {
          setSnackMessage("File size is greater than 1MB");
          setIsSnackError(true);
          setSnackOpen(true);
          setFormData((prevData) => ({
            ...prevData,
            file_upload_proposal_name: null,
            file_upload_proposal: null,
          }));
        }
      } else {
        setSnackMessage("File should be in .pdf format");
        setIsSnackError(true);
        setSnackOpen(true);
        setFormData((prevData) => ({
          ...prevData,
          brochure_name: null,
          brochure: null,
        }));
      }
    }
  };

  const handleLetterChange = (e) => {
    let file = e.target.files[0];
    if (!file) return;

    let fileKey = e.target.name;
    let fileType = file.name.split(".").pop().toLowerCase();
    if (fileKey === "letter") {
      const allowedTypes = ["pdf"];

      if (allowedTypes.includes(fileType)) {
        let fileSizeMB = file.size / Math.pow(1024, 2);

        if (fileSizeMB < 1) {
          setFormData((prevData) => ({
            ...prevData,
            letter_name: file.name,
            letter: file,
          }));
        } else {
          setSnackMessage("File size is greater than 1MB");
          setIsSnackError(true);
          setSnackOpen(true);
          setFormData((prevData) => ({
            ...prevData,
            letter: null,
            letter_name: null,
          }));
        }
      } else {
        setSnackMessage("File should be in .pdf format");
        setIsSnackError(true);
        setSnackOpen(true);
        setFormData((prevData) => ({
          ...prevData,
          brochure_name: null,
          brochure: null,
        }));
      }
    }
  };

  const snackbarClose = (flag) => {
    console.log(flag);
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (selectedCatId === "others") {
      props.history.push("/");
    }
  };
  const handleEducationalChange = (e, i) => {
    let data = { ...formData };

    data.students[i] = {
      ...data.students[i],
      [e.target.name]: e.target.value,
    };

    setFormData(data);
  };
  // ========================

  // =============================
  const addEducationalQualifications = () => {
    setFormData((prevData) => ({
      ...prevData,
      students: [
        ...prevData.students,
        {
          student_name: "",
          semester: "",
          branch: "",
          duration: "",
          // mark: "",
          resume: null,
          photo: null,
          marklist: null,
        },
      ],
    }));
  };

  const removeEducationalQualifications = (index) => {
    setFormData((prevData) => ({
      students: prevData.students.filter((_, i) => i !== index),
    }));
  };
  const handleEducationalFileChange = (e, i) => {
    let file = e.target.files[0];
    if (!file) return;

    let size = file.size;
    let type = file.name.split(".").pop().toLowerCase();
    let fieldName = e.target.name;

    if (type === "png" || type === "jpeg" || type === "jpg") {
      let mb = size / Math.pow(1024, 2);
      let updatedStudents = [...formData.students];

      if (mb < 1) {
        updatedStudents[i] = {
          ...updatedStudents[i],
          [fieldName]: file,
          [`${fieldName}_file_name`]: file.name,
        };
      } else {
        setSnackMessage("File size is greater than 1MB");
        setIsSnackError(true);
        setSnackOpen(true);
        updatedStudents[i] = {
          ...updatedStudents[i],
          [fieldName]: null,
          [`${fieldName}_file_name`]: null,
        };
      }

      setFormData({ ...formData, students: updatedStudents });
    } else {
      setSnackMessage("File should be in .jpg / .jpeg / .png format");
      setIsSnackError(true);
      setSnackOpen(true);
      let updatedStudents = [...formData.students];
      updatedStudents[i] = {
        ...updatedStudents[i],
        [fieldName]: null,
        [`${fieldName}_file_name`]: null,
      };

      setFormData({ ...formData, students: updatedStudents });
    }
  };

  const handleMarkListFileChange = (e, i) => {
    let size = e.target.files[0].size;
    let type = e.target.files[0].name.split(".").pop();
    let data = { ...formData };
    if (type === "png" || type === "jpeg" || type === "jpg") {
      let mb = size / Math.pow(1024, 2);
      if (mb < 1) {
        data.students[i] = {
          ...data.students[i],
          [e.target.name]: e.target.files[0],
          file_name: e.target.files[0].name,
        };
        setFormData(data);
      } else {
        setSnackMessage("File size is greater than 1MB");
        setIsSnackError(true);
        setSnackOpen(true);
        data.students[i] = {
          ...data.students[i],
          [e.target.name]: null,
          file_name: null,
        };
        setFormData(data);
      }
    } else {
      setSnackMessage("File should be in .jpg / .jpeg / .png  format");
      setIsSnackError(true);
      setSnackOpen(true);
      data.students[i] = {
        ...data.students[i],
        [e.target.name]: null,
        file_name: null,
      };
      setFormData(data);
    }
  };
  const handleProposalFileChange = (e, i) => {
    let file = e.target.files[0];
    if (!file) return;

    let fileKey = e.target.name;
    let fileType = file.name.split(".").pop().toLowerCase();
    const allowedTypes = ["pdf", "doc", "docx"];

    if (allowedTypes.includes(fileType)) {
      let fileSizeMB = file.size / (1024 * 1024);

      if (fileSizeMB <= 1) {
        setFormData((prevData) => ({
          ...prevData,
          students: prevData.students.map((student, index) =>
            index === i ? { ...student, [fileKey]: file } : student
          ),
        }));
      } else {
        setSnackMessage("File size should be less than 1MB");
        setIsSnackError(true);
        setSnackOpen(true);

        setFormData((prevData) => ({
          ...prevData,
          students: prevData.students.map((student, index) =>
            index === i ? { ...student, [fileKey]: null } : student
          ),
        }));
      }
    } else {
      setSnackMessage("File should be in .pdf, .doc, or .docx format");
      setIsSnackError(true);
      setSnackOpen(true);

      setFormData((prevData) => ({
        ...prevData,
        students: prevData.students.map((student, index) =>
          index === i ? { ...student, [fileKey]: null } : student
        ),
      }));
    }
  };
  const handleResumeFileChange = (e, i) => {
    let size = e.target.files[0].size;
    let type = e.target.files[0].name.split(".").pop();
    let data = { ...formData };
    if (type === "png" || type === "jpeg" || type === "jpg") {
      let mb = size / Math.pow(1024, 2);
      if (mb < 1) {
        data.students[i] = {
          ...data.students[i],
          [e.target.name]: e.target.files[0],
          file_name: e.target.files[0].name,
        };
        setFormData(data);
      } else {
        setSnackMessage("File size is greater than 1MB");
        setIsSnackError(true);
        setSnackOpen(true);
        data.students[i] = {
          ...data.students[i],
          [e.target.name]: null,
          file_name: null,
        };
        setFormData(data);
      }
    } else {
      setSnackMessage("File should be in .jpg / .jpeg / .png  format");
      setIsSnackError(true);
      setSnackOpen(true);
      data.students[i] = {
        ...data.students[i],
        [e.target.name]: null,
        file_name: null,
      };
      setFormData(data);
    }
  };
  const handleFileChange = (e) => {
    let file = e.target.files[0];
    if (!file) return;

    let size = file.size;
    let type = file.name.split(".").pop().toLowerCase();
    let fieldName = e.target.name;

    if (type === "jpg" || type === "jpeg" || type === "png") {
      let mb = size / 1024;

      if (mb < 5024) {
        setFormData((prevData) => ({
          ...prevData,
          [`${fieldName}_file_name`]: file.name,
          [fieldName]: file,
        }));
      } else {
        setSnackMessage("File size is greater than 5MB");
        setIsSnackError(true);
        setSnackOpen(true);

        setFormData((prevData) => ({
          ...prevData,
          [`${fieldName}_file_name`]: null,
          [fieldName]: null,
        }));
      }
    } else {
      setSnackMessage("File should be in .jpg / .jpeg / .png format");
      setIsSnackError(true);
      setSnackOpen(true);

      setFormData((prevData) => ({
        ...prevData,
        [`${fieldName}_file_name`]: null,
        [fieldName]: null,
      }));
    }
  };

  const handleEducationalNumberChange = (e, i) => {
    let data = { ...formData };
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
    data.students[i] = {
      ...data.students[i],
      [name]: newValue,
    };

    setFormData(data);
  };
  const handleNumberChange = (e) => {
    let data = { ...formData };
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9]/g, "");
    data = { ...data, [name]: newValue };
    setFormData(data);
  };
  const textFieldChange = (e) => {
    if (
      e.target.name === "project_guide1_email" ||
      e.target.name === "project_guide2_email"
    ) {
      let erroremail = !EmailValidate(e.target.value);
      console.log(erroremail);
      setError({ ...error, [e.target.name]: erroremail });
      console.log(error);
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  console.log(formData);
  return (
    <>
      <form onSubmit={handlepreview}>
        <div className="expert">
          <div>
            <div>
              <div className="col-xs-12 col-sm-12 mb-2">
                <div className="header-label mb-1">Institution</div>
                <select
                  className="form-select selectbox mandatory-select"
                  required
                  name="institution_id"
                  aria-label="Default select example"
                  value={formData.institution_id}
                  onChange={handleCategoryChange}
                >
                  <option value="">-- Select --</option>
                  {institutions?.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.institution_name}
                    </option>
                  ))}
                  <option value="others">Others</option>
                </select>

                {institutionError && (
                  <div style={{ color: "red", marginTop: "4px" }}>
                    {institutionError}
                  </div>
                )}
              </div>
              <div className="col-xs-12 col-sm-12">
                <CommonForm
                  fieldType="text"
                  label="Proposal Title"
                  required
                  name="project_title"
                  value={formData.project_title ?? ""}
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>

              <div className="col-xs-12 col-sm-12 mb-2">
                <CommonForm
                  fieldType="file"
                  required={!formData?.letter?.name ? true : false}
                  fileName={formData.file_name ?? formData?.letter?.name}
                  label="Upload Recommendation Letter (The recommendation letter from the Academic institution head/head of the department)"
                  name="letter"
                  {...props}
                  id="letter"
                  className="no-margin"
                  accept=".pdf,.doc,.docx"
                  type="file"
                  variant="outlined"
                  onChange={handleLetterChange}
                />
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-12 mb-2 ">
                  <div className="control-label mylabel">Project Guide</div>
                  <div className="col-xs-12 col-sm-12 mb-2">
                    <CommonForm
                      fieldType="text"
                      placeholder="Project Guide 1 "
                      required
                      className="no-margin"
                      name="project_guide1"
                      value={formData.project_guide1 ?? ""}
                      onChange={(e) => {
                        textFieldChange(e);
                      }}
                      {...props}
                    />
                  </div>

                  <div className="col-xs-12 col-sm-12 mb-2">
                    <CommonForm
                      fieldType="text"
                      placeholder="Phone number of Project Guide 1"
                      required
                      className="no-margin"
                      name="project_guide1_phone"
                      maxLength="10"
                      value={formData.project_guide1_phone ?? ""}
                      onChange={(e) => {
                        handleNumberChange(e);
                      }}
                      {...props}
                    />
                  </div>
                  <div className="col-xs-12 col-sm-12 mb-2">
                    <CommonForm
                      fieldType="email"
                      placeholder="Email of Project Guide 1"
                      required
                      className="no-margin"
                      name="project_guide1_email"
                      value={formData.project_guide1_email ?? ""}
                      onChange={(e) => {
                        textFieldChange(e);
                      }}
                      {...props}
                    />
                  </div>
                  <br />

                  <div className="col-xs-12 col-sm-12 mb-2">
                    <CommonForm
                      fieldType="text"
                      placeholder="Project Guide 2"
                      required
                      value={formData.project_guide2 ?? ""}
                      className="no-margin"
                      name="project_guide2"
                      onChange={(e) => {
                        textFieldChange(e);
                      }}
                      {...props}
                    />
                  </div>
                  <div className="col-xs-12 col-sm-12 mb-2">
                    <CommonForm
                      fieldType="text"
                      placeholder="Phone number of Project Guide 2"
                      required
                      className="no-margin"
                      name="project_guide2_phone"
                      maxLength="10"
                      value={formData.project_guide2_phone ?? ""}
                      onChange={(e) => {
                        handleNumberChange(e);
                      }}
                      {...props}
                    />
                  </div>
                  <div className="col-xs-12 col-sm-12">
                    <CommonForm
                      fieldType="email"
                      placeholder="Email of Project Guide 2"
                      required
                      className="no-margin"
                      name="project_guide2_email"
                      value={formData.project_guide2_email ?? ""}
                      onChange={(e) => {
                        textFieldChange(e);
                      }}
                      {...props}
                    />
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-6 my-2 d-flex justify-content-start align-items-center ">
                <div className="control-label">
                  <b>Do you want to add group members?</b> :{" "}
                </div>
                <div className="d-flex">
                  <CommonForm
                    fieldType="radio"
                    label="Yes"
                    required
                    name="group"
                    value="yes"
                    checked={formData?.group === "yes"}
                    onChange={() => {
                      setFormData((prev) => ({ ...prev, group: "yes" }));
                      setShowGroupMembers(true);
                    }}
                    {...props}
                  />

                  <CommonForm
                    fieldType="radio"
                    label="No"
                    required
                    name="group"
                    value="no"
                    checked={formData?.group === "no"}
                    onChange={() => {
                      setFormData((prev) => ({ ...prev, group: "no" }));
                      setShowGroupMembers(false);
                    }}
                    {...props}
                  />
                </div>
              </div>

              <div className="header-label">
                {showGroupMembers ? "Leader Details" : "Student Details"}
              </div>

              <div className="section-datas-cont mb-3">
                <div className="section-Cont">
                  <div className="row">
                    <div className="col-xs-12 col-sm-4">
                      <CommonForm
                        fieldType="text"
                        label="Student Name"
                        required
                        name="leader_student_name"
                        value={formData.leader_student_name ?? ""}
                        onChange={(e) => {
                          textFieldChange(e);
                        }}
                        {...props}
                      />
                    </div>{" "}
                    <div className="col-xs-12 col-sm-4">
                      <CommonForm
                        fieldType="number"
                        label="Phone Number of the leader"
                        disabled
                        value={formData?.phone_number}
                        required
                        name="phone"
                        {...props}
                      />
                    </div>
                    <div className="col-xs-12 col-sm-4">
                      <CommonForm
                        fieldType="number"
                        label="Semester"
                        required
                        name="leader_semester"
                        minlength="1"
                        maxLength="1"
                        value={formData.leader_semester ?? ""}
                        onChange={(e) => {
                          textFieldChange(e);
                        }}
                        {...props}
                      />
                    </div>
                    <div className="col-xs-6 col-sm-4">
                      <CommonForm
                        fieldType="text"
                        label="Branch"
                        required
                        name="leader_branch"
                        value={formData.leader_branch ?? ""}
                        onChange={(e) => {
                          textFieldChange(e);
                        }}
                        {...props}
                      />
                    </div>{" "}
                    {/* <div className="col-xs-6 col-sm-4">
                      <CommonForm
                        fieldType="number"
                        label="Previous Year Mark"
                        required
                        maxLength="4"
                        name="leader_mark"
                        value={formData.leader_mark ?? ""}
                        onChange={(e) => {
                          textFieldChange(e);
                        }}
                        {...props}
                      />
                    </div> */}
                    <div className="col-xs-6 col-sm-4">
                      <CommonForm
                        fieldType="text"
                        label="Duration/Period of study"
                        required
                        maxLength="4"
                        name="leader_duration"
                        value={formData.leader_duration ?? ""}
                        onChange={(e) => {
                          textFieldChange(e);
                        }}
                        {...props}
                      />
                    </div>
                    <div className="col-xs-6 col-sm-4">
                      <CommonForm
                        fieldType="email"
                        label="Email of the leader"
                        required
                        className="no-margin"
                        name="leader_email"
                        value={formData.leader_email ?? ""}
                        onChange={(e) => {
                          textFieldChange(e);
                        }}
                        {...props}
                      />
                    </div>
                    <div className="col-12">
                      <CommonForm
                        fieldType="file"
                        required={!formData?.leader_photo?.name ? true : false}
                        fileName={
                          formData?.file_name ?? formData?.leader_photo?.name
                        }
                        label="Upload Photo"
                        name="leader_photo"
                        {...props}
                        id="leader_photo"
                        className="no-margin"
                        accept=".jpg,.jpeg,.png"
                        type="file"
                        variant="outlined"
                        onChange={(e) => {
                          handleFileChange(e);
                        }}
                        // onChange={handleFileChange}
                      />
                      <div className="file-up-helper">
                        *Upload only .jpg , .jpeg , .png format and File size
                        should be less than size 1MB
                      </div>
                    </div>
                    <div className="col-12">
                      <CommonForm
                        fieldType="file"
                        required={
                          !formData?.leader_marklist?.name ? true : false
                        }
                        fileName={
                          formData.file_name ?? formData?.leader_marklist?.name
                        }
                        label="Proof of previous year marklist"
                        name="leader_marklist"
                        {...props}
                        id="leader_marklist"
                        className="no-margin"
                        accept=".pdf,.doc,.docx"
                        type="file"
                        variant="outlined"
                        onChange={handleMarkListChange}
                      />
                      <div className="file-up-helper">
                        *Upload only .pdf, .doc, .docx format and File size
                        should be less than size 1MB
                      </div>
                    </div>
                    <div className="col-12">
                      <CommonForm
                        fieldType="file"
                        required={!formData?.leader_resume?.name ? true : false}
                        fileName={
                          formData.file_name ?? formData?.leader_resume?.name
                        }
                        label="Biodata"
                        name="leader_resume"
                        {...props}
                        id="leader_resume"
                        className="no-margin"
                        accept=".pdf,.doc,.docx"
                        type="file"
                        variant="outlined"
                        onChange={handleResumeUploadChange}
                      />
                      <div className="file-up-helper">
                        *Upload only .pdf, .doc, .docx format and File size
                        should be less than size 1MB
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {showGroupMembers && (
                <>
                  <div className="header-label">Add Group Members</div>
                  {formData.students?.map((e, i) => (
                    <div className="section-datas-cont mb-3">
                      <div className="section-Cont">
                        <div className="row">
                          <div className="col-xs-12 col-sm-4">
                            <CommonForm
                              fieldType="text"
                              label="Student Name"
                              required
                              name="student_name"
                              value={e?.student_name ?? ""}
                              onChange={(e) => {
                                handleEducationalChange(e, i);
                              }}
                              {...props}
                            />
                          </div>{" "}
                          <div className="col-xs-12 col-sm-4">
                            <CommonForm
                              fieldType="number"
                              label="Semester"
                              required
                              name="semester"
                              minlength="1"
                              maxLength="1"
                              value={e?.semester ?? ""}
                              onChange={(e) => {
                                handleEducationalChange(e, i);
                              }}
                              {...props}
                            />
                          </div>
                          <div className="col-xs-6 col-sm-4">
                            <CommonForm
                              fieldType="text"
                              label="Branch"
                              required
                              name="branch"
                              value={e?.branch ?? ""}
                              onChange={(e) => {
                                handleEducationalChange(e, i);
                              }}
                              {...props}
                            />
                          </div>{" "}
                          <div className="col-xs-6 col-sm-4">
                            <CommonForm
                              fieldType="text"
                              label="Duration/Period of study"
                              required
                              maxLength="4"
                              name="duration"
                              value={e?.duration ?? ""}
                              onChange={(e) => {
                                handleEducationalNumberChange(e, i);
                              }}
                              {...props}
                            />
                          </div>
                          {/* <div className="col-xs-6 col-sm-4">
                            <CommonForm
                              fieldType="number"
                              label="Previous Year Mark"
                              required
                              maxLength="4"
                              name="mark"
                              value={e?.mark ?? ""}
                              onChange={(e) => {
                                handleEducationalNumberChange(e, i);
                              }}
                              {...props}
                            />
                          </div> */}
                          <div className="col-12">
                            <CommonForm
                              fieldType="file"
                              required={!e.file_name ? true : false}
                              fileName={e?.file_name}
                              label="Upload Photo"
                              name="photo"
                              {...props}
                              id="upload_proposal"
                              className="no-margin"
                              accept=".jpg,.jpeg,.png"
                              type="file"
                              variant="outlined"
                              onChange={(e) => {
                                handleEducationalFileChange(e, i);
                              }}
                            />
                            <div className="file-up-helper">
                              *Upload only .jpg , .jpeg , .png format and File
                              size should be less than size 1MB
                            </div>
                          </div>
                          <div className="col-12">
                            <CommonForm
                              fieldType="file"
                              required={!e.file_name ? true : false}
                              fileName={e?.file_name}
                              label="Proof of previous year marklist"
                              name="marklist"
                              {...props}
                              id="marklist"
                              className="no-margin"
                              accept=".pdf,.doc,.docx"
                              type="file"
                              variant="outlined"
                              onChange={(e) => {
                                handleProposalFileChange(e, i);
                              }}
                            />
                            <div className="file-up-helper">
                              *Upload only .pdf, .doc, .docx format and File
                              size should be less than size 1MB
                            </div>
                          </div>
                          <div className="col-12">
                            <CommonForm
                              fieldType="file"
                              required={!e.file_name ? true : false}
                              fileName={e?.file_name}
                              label="Biodata"
                              name="resume"
                              {...props}
                              id="resume"
                              className="no-margin"
                              accept=".pdf,.doc,.docx"
                              type="file"
                              variant="outlined"
                              onChange={(e) => {
                                handleProposalFileChange(e, i);
                              }}
                              // onChange={handleFileChange}
                            />
                            <div className="file-up-helper">
                              *Upload only .pdf, .doc, .docx format and File
                              size should be less than size 1MB
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="more-btn-cnt">
                        {formData.students.length === i + 1 && (
                          <button
                            style={{ marginLeft: 5 }}
                            type="button"
                            {...props}
                            className="btn btn-primary"
                            onClick={(e) => addEducationalQualifications(i)}
                          >
                            Add More
                          </button>
                        )}
                        {formData.students.length > 1 && (
                          <button
                            {...props}
                            type="button"
                            className="btn btn-primary"
                            onClick={(e) => removeEducationalQualifications(i)}
                          >
                            Remove
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
          <div className="col-xs-12 col-sm-12 mt-0">
            <CommonForm
              fieldType="text"
              label="Short Details  of Proposal"
              multiline
              required
              value={formData.short_proposal_details ?? ""}
              className="no-margin"
              name="short_proposal_details"
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />
          </div>

          <div className="section-datas-cont">
            <div className="col-12">
              <CommonForm
                fieldType="file"
                required={!formData.file_upload_proposal?.name ? true : false}
                label="Upload  Your Proposal"
                name="file_upload_proposal"
                {...props}
                fileName={
                  formData.file_name ?? formData?.file_upload_proposal?.name
                }
                id="file_upload_proposal"
                accept=".pdf,.doc,.docx"
                type="file"
                variant="outlined"
                onChange={handleProposalFileUploadChange}
              />
              <div className="file-up-helper">
                *Upload only .pdf,.doc ,docx format and Size should be less than
                5MB
              </div>
            </div>
          </div>
          {/* </fieldset> */}

          <div className="footer-buttons">
            <button type="submit" className="primary-btn">
              SUBMIT TO PREVIEW
            </button>
          </div>
          <Snackbar
            message={snackMessage}
            error={isSnackError}
            open={snackOpen}
            close={snackbarClose}
          />
        </div>
      </form>
    </>
  );
}
